module.exports = __webpack_public_path__ + "media/images/countrysquared/cr-a7baabf0a1945875fa2245b91f52d60e.svg";